/** @typedef {import('components/comments/data/types').CommentReactionType} CommentReactionType */

/**
 * List of all possible reaction types.
 *
 * @type {CommentReactionType[]}
 */
export const COMMENT_REACTION_TYPES = ['like', 'dislike', 'heart', 'laugh', 'sad'];
